export default __webpack_public_path__ + "static/logo-1-75279de39dd586d2baae0f32efdc931c.png";